import { createApp } from 'vue';
import { createAgonI18n } from '../../i18n';
import NonCustomItemDetail from './NonCustomItemDetail.vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

interface RootProps {
  recaptchaSiteKey: string;
  culture: string;
  currency: string;
  blobDomain: string;
  designId: string;
  styleId: string;
  fabricId: string;
  liningId: string;
  style: never;
  assembly: never;
  design: never;
  fabrics: never[];
  liningOptions: never[];
  products: never[];
  showDisplayCurrency: boolean;
  displayCurrency: string;
  displayExchangeRate: string;
  xsrfTokenInput: string;
  xsrfToken: string;
  isAuthenticated: boolean;
  isPrintWaterPoloCap: boolean;
  isWaterPoloCap: boolean;
  hasCustomizeButton: boolean;
  customizeMethod: string;
  customizeUrl: string;
  customizeReturnUrl: string;
  sendMessageUrl: string;
  solidColorId: string | null;
  printIconImageUrl: string | null;
  favorites: string[];
  cartAddUrl: string;
}

declare const rootProps: RootProps;

const i18n = createAgonI18n(rootProps.culture);

createApp(NonCustomItemDetail, rootProps as never)
  .use(i18n)
  .use(VueReCaptcha, { siteKey: rootProps.recaptchaSiteKey, loaderOptions: {} })
  .mount('#app');
